var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebookIcon16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M15.994 8.046C15.994 3.602 12.414 0 7.997 0S0 3.602 0 8.046c0 4.016 2.924 7.344 6.748 7.948v-5.622H4.717V8.046h2.03V6.27c0-2.013 1.195-3.13 3.021-3.13.875 0 1.79.157 1.79.157v1.98H10.55c-.993 0-1.303.62-1.303 1.256v1.511h2.217l-.354 2.326H9.247v5.623c3.823-.604 6.747-3.932 6.747-7.948"
})));
export default SvgFacebookIcon16;